module.exports = __webpack_public_path__ + "img/front concealed zipper length.ec581460.png";